module.exports = __webpack_public_path__ + "static/media/image.644c984b.svg";